import { useTranslation } from 'react-i18next'

import pageLanguage from '../../functions/pageLanguage'
import { useScroll } from '../../functions/useScroll'
import RefinedCategories from '../DeviceCategories/RefinedCategories'
import CustomInfiniteHits2 from '../InfiniteHits/InfiniteHits'
import MobileFilter from '../MobileFilter/MobileFilter'
import CustomSortBy from '../MobileSort/CustomSortBy'
import CustomStats from '../Stats/Stats'
import './MobileComponent.scss'
interface MobileComponentProps {
  currentRefinement?: any;
  currentTime: number;
}

const MobileComponent = ({
  currentRefinement,
  currentTime,
}: MobileComponentProps) => {
  const { t } = useTranslation()
  const win = window
  const lang = pageLanguage()
  const { scrollY } = useScroll();

  const categoryAttribute = lang === "ar" ? "category.deviceSubType.valueAr" : "category.deviceSubType.valueEn"

  return (
    <div className={`mobileComponent ${scrollY > 100.00 ? 'mobileScrollClass' : ''}`}>
      <div className="mobileDeviceTitle">
        {t('devices')}
      </div>
      <div className="mobileCategories">
        <RefinedCategories attribute={categoryAttribute} facetOrdering={true} defaultRefinement={[t('SmartPhones')]} />
      </div>
      <div className="mobileSortAndFilter">
        <div className="mobileStats">
          {currentRefinement !== '' ? (
            <>
              <CustomStats
                lang={win.document.documentElement.lang}
                query={currentRefinement}
              />
            </>
          ) : null}
        </div>
        <div className="sortAndFilter">
          <CustomSortBy />
          <MobileFilter />
        </div>
      </div>
      <div className="mobile-list">
        {currentRefinement !== '' ? (
          <div className="devices__MobileContent">
            <CustomInfiniteHits2 currentTime={currentTime} />
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default MobileComponent
